import { RestClient } from './RestClient'

export class SubscriptionClient extends RestClient {
  /**
   * SubscriptionClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    this.baseUrl = `/teams`
  }

  /**
   * Create a new subscription
   *
   * @param {number} teamId - Team id
   * @param {string} plan - The stripe plan name
   * @param {string|undefined} paymentMethod
   * @param {string|undefined} couponCode
   *
   * @returns {AxiosPromise}
   */
  create (teamId, plan, paymentMethod = undefined, couponCode = undefined) {
    return this.call('post', `${this.baseUrl}/${teamId}/subscription`, {
      plan,
      payment_method: paymentMethod,
      coupon: couponCode
    })
  }

  /**
   * Update the payment information of an existing subscription
   *
   * @param {number} teamId - Team id
   * @param {string} source
   *
   * @returns {AxiosPromise}
   */
  update (teamId, source) {
    return this.call('patch', `${this.baseUrl}/${teamId}/subscription`, { source })
  }

  /**
   * Cancel the subscription of a team
   *
   * @param {number} teamId - Team id
   * @param {string} password
   *
   * @returns {AxiosPromise}
   */
  cancel (teamId, password) {
    return this.call('delete', `${this.baseUrl}/${teamId}/subscription`, { confirmation_password: password })
  }

  /**
   * Get all subscription invoices of a team
   *
   * @param {number} teamId - Team id
   *
   * @returns {AxiosPromise}
   */
  getInvoices (teamId) {
    return this.call('get', `${this.baseUrl}/${teamId}/subscription/invoices`)
  }

  /**
   * Validate a coupon code
   *
   * @param {number} teamId - Team id
   * @param {string} coupon
   *
   * @returns {AxiosPromise}
   */
  validateCoupon (teamId, coupon) {
    return this.call('post', `${this.baseUrl}/${teamId}/subscription/coupon/validate`, { coupon })
  }

  /**
   * Get a stripe setup intent
   *
   * @param {number} teamId - Team id
   * @param {string} paymentMethod
   *
   * @returns {AxiosPromise}
   */
  createSetupIntent (teamId, paymentMethod) {
    return this.call('post', `${this.baseUrl}/${teamId}/subscription/setup-intent`, {
      payment_method: paymentMethod
    })
  }
}
